/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Collapse,
  Fade,
  Grid,
} from "@material-ui/core";
import React, { Fragment, useEffect, useRef, useState } from "react";
import useStyles from "../../../styles";
import Home from "../../../assets/icon/Home.svg";
import Menu from "./components/Menu";
import Notification from "../../../assets/icon/Notification.svg";
import ProfileSection from "./components/ProfileSection";
import LoginSignUp from "./components/LoginSignUp";
import { useDispatch, useSelector } from "react-redux";
import {
  getLastUSerSearches,
  getProfileDetail,
  setNotificationsSeen,
  setSearchActivityQuery,
} from "../../../routes/actions";
import { useLocation } from "react-router";
import history from "../../../utilize/history";
import useOutSideClick from "utilize/Hook/useOutSideClick";
import { Link } from "react-router-dom";
import Search from "assets/icon/Search.svg";
import userIcon from "assets/icon/vuesax-linear-profile-2user.svg";
import unitIcon from "assets/icon/vuesax-outline-courthouse - white.svg";
import activityIcon from "assets/icon/vuesax-linear-gallery.svg";

export default function DeskHeader() {
  const classes = useStyles();
  const { isLogin } = useSelector((state) => state.main);
  const { currentUser } = useSelector((state) => state.main);
  const { searchLoading } = useSelector((state) => state.main);
  const { searchHistoryResultList } = useSelector((state) => state.main);
  const [seeMore, setSeeMore] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [focusInput, setFocusInput] = useState(false);
  const [searchField, setSearchField] = useState("user");
  const notificationRef = useRef();

  useOutSideClick(notificationRef, () => {
    setNotificationPopup(false);
  });

  useEffect(() => {
    if (localStorage.getItem("aghighToken")?.length > 4 && isLogin) {
      dispatch(getProfileDetail(localStorage.getItem("aghighToken")));
    }
  }, []);

  const handleSeenNotifications = (id) => {
    setNotificationPopup(false);
    dispatch(setNotificationsSeen({ notificationId: id }));
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };
  const handleFocusInput = (e) => {
    setFocusInput(true);
    dispatch(getLastUSerSearches());
  };
  const handleBlurInput = (e) => {
    if (searchValue?.length === 0) {
      setFocusInput(false);
    }
  };

  const handleSetSearchField = (field) => {
    setSearchField(field);
  };

  const searchRequest = (e) => {
    setFocusInput(false);

    if (searchField === "user") {
      dispatch(setSearchActivityQuery(searchValue));
      history.push(`/search/user/${searchValue}`);
    }

    if (searchField === "unit") {
      dispatch(setSearchActivityQuery(searchValue));
      history.push(`/search/unit/${searchValue}`);
    }

    if (searchField === "activity") {
      dispatch(setSearchActivityQuery(searchValue));
      history.push(`/activities/search`);
    }
    setSearchValue("");
    setFocusInput(true);
  };

  return (
    <Grid container style={{ zIndex: 2000 }}>
      <Grid
        container
        justify="center"
        className={
          location.pathname !== "/"
            ? classes.headerContainer2
            : classes.headerContainer
        }
      >
        <Grid
          container
          className={classes.headerBox}
          justify="space-between"
          alignItems="center"
        >
          <Grid item className={classes.headerRightSection}>
            {/* <img
							src={Logo}
							className={classes.logo}
							alt="logo"
							style={{
								marginRight:
									location.pathname !== "/" 
										? 21
										: 35,
							}}
						/> */}
            {isLogin ? (
              <>
                <img
                  src={Home}
                  className={classes.HomeIcon}
                  alt="Home"
                  onClick={() => history.push("/")}
                />
                <Menu />
              </>
            ) : null}
          </Grid>
          {isLogin ? (
            <Grid item className={classes.ProfileSectionContainer}>
              <ClickAwayListener onClickAway={() => setFocusInput(false)}>
                <Grid container className={classes.searchContainer}>
                  <input
                    className={
                      !focusInput && searchValue?.length
                        ? classes.searchInput
                        : classes.activeInput
                    }
                    value={searchValue}
                    onChange={handleSearch}
                    onFocus={handleFocusInput}
                    onBlur={handleBlurInput}
                    placeholder="جستجو"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        searchRequest();
                      }
                    }}
                  />
                  <img
                    src={Search}
                    style={{
                      position: "absolute",
                      left: 8,
                      top: 8,
                      cursor: "pointer",
                    }}
                    alt="search"
                    onClick={searchRequest}
                  />
                  <Fade in={focusInput && searchValue?.length > 2}>
                    <Grid
                      container
                      direction="column"
                      className={classes.searchFadeContainer}
                    >
                      <Grid
                        container
                        justify="space-between"
                        style={{ padding: "0 10px" }}
                      >
                        <Grid
                          container
                          className={
                            searchField === "user"
                              ? classes.activeSearchSection
                              : classes.searchSection
                          }
                          onClick={() => handleSetSearchField("user")}
                        >
                          <img
                            src={userIcon}
                            alt="userIcon"
                            style={{ marginLeft: 3, width: 17 }}
                          />
                          اعضا
                        </Grid>
                        <Grid
                          container
                          className={
                            searchField === "unit"
                              ? classes.activeSearchSection
                              : classes.searchSection
                          }
                          onClick={() => handleSetSearchField("unit")}
                        >
                          <img
                            src={unitIcon}
                            alt="unitIcon"
                            style={{ marginLeft: 3, width: 17 }}
                          />
                          مدرسه
                        </Grid>
                        <Grid
                          container
                          className={
                            searchField === "activity"
                              ? classes.activeSearchSection
                              : classes.searchSection
                          }
                          onClick={() => handleSetSearchField("activity")}
                        >
                          <img
                            src={activityIcon}
                            alt="activityIcon"
                            style={{ marginLeft: 3, width: 17 }}
                          />
                          فعالیت ها
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        direction="column"
                        style={{ padding: "0 10px" }}
                      >
                        {searchField === "user" && (
                          <>
                            <Grid
                              item
                              style={{
                                borderBottom: "1px solid #bbb",
                                margin: "10px 0",
                              }}
                            >
                              سابقه جستجو
                            </Grid>
                            {searchHistoryResultList?.user
                              ?.slice(0, 4)
                              .map((item) => (
                                <Grid item>{item}</Grid>
                              ))}
                          </>
                        )}

                        {searchField === "unit" && (
                          <>
                            <Grid
                              item
                              style={{
                                borderBottom: "1px solid #bbb",
                                margin: "10px 0",
                              }}
                            >
                              سابقه جستجو
                            </Grid>
                            {searchHistoryResultList?.unit
                              ?.slice(0, 4)
                              ?.map((item) => (
                                <Grid item>{item}</Grid>
                              ))}
                          </>
                        )}
                        {searchField === "activity" && (
                          <>
                            <Grid
                              item
                              style={{
                                borderBottom: "1px solid #bbb",
                                margin: "10px 0",
                              }}
                            >
                              سابقه جستجو
                            </Grid>
                            {searchHistoryResultList?.activity
                              ?.slice(0, 4)
                              ?.map((item) => (
                                <Grid item>{item}</Grid>
                              ))}
                          </>
                        )}
                      </Grid>
                      <Button
                        color="primary"
                        disabled={
                          searchField === "default" || !searchValue?.length
                        }
                        className={classes.searchSubmit}
                        classes={{ disabled: classes.searchSubmitDisabled }}
                        onClick={searchRequest}
                      >
                        {searchLoading ? <CircularProgress /> : "جستجو"}
                      </Button>
                    </Grid>
                  </Fade>
                </Grid>
              </ClickAwayListener>
              <Grid item className={classes.es5Container}>
                <div ref={notificationRef} style={{ display: "flex" }}>
                  <img
                    src={Notification}
                    className={classes.es5}
                    alt="Notification"
                    onClick={() => setNotificationPopup(!notificationPopup)}
                    style={{
                      cursor:
                        currentUser.notifications.length > 0 ? "pointer" : null,
                    }}
                  />
                  {currentUser.notifications.length > 0 && (
                    <div
                      style={{
                        width: 7,
                        height: 7,
                        backgroundColor: "red",
                        borderRadius: "50%",
                        position: "absolute",
                        top: 4,
                        right: 12,
                      }}
                    />
                  )}
                  <Fade
                    in={
                      notificationPopup && currentUser.notifications.length > 0
                    }
                  >
                    <Grid
                      container
                      direction="column"
                      wrap="nowrap"
                      className={classes.notificationFade}
                    >
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          transform: "rotate(45deg)",
                          backgroundColor: "#fff",
                          position: "absolute",
                          top: -5,
                          right: 20,
                        }}
                      />
                      <Grid
                        container
                        direction="column"
                        wrap="nowrap"
                        className={classes.allNotification}
                      >
                        {currentUser.notifications
                          ?.slice(0, 7)
                          ?.map((not, index) => {
                            return (
                              <Fragment key={not?.id}>
                                <Grid
                                  container
                                  className={classes.notificationItem}
                                  component={Link}
                                  to={{
                                    pathname: `/activity/detail/${not?.url}`,
                                  }}
                                  onClick={() =>
                                    handleSeenNotifications(not?.id)
                                  }
                                >
                                  <Grid
                                    container
                                    className={classes.notificationTitle}
                                  >
                                    {not?.title}:
                                  </Grid>
                                  <Grid
                                    container
                                    className={classes.notificationBody}
                                  >
                                    {not?.body}
                                  </Grid>
                                </Grid>
                              </Fragment>
                            );
                          })}
                        <Collapse in={seeMore}>
                          {currentUser.notifications
                            ?.slice(8, currentUser.notifications?.length)
                            ?.map((not) => {
                              return (
                                <Fragment key={not?.id}>
                                  <Grid
                                    container
                                    className={classes.notificationItem}
                                    component={Link}
                                    to={{
                                      pathname: `/activity/detail/${not?.url}`,
                                    }}
                                    onClick={() =>
                                      handleSeenNotifications(not?.id)
                                    }
                                  >
                                    <Grid
                                      container
                                      className={classes.notificationTitle}
                                    >
                                      {not?.title}:
                                    </Grid>
                                    <Grid
                                      container
                                      className={classes.notificationBody}
                                    >
                                      {not?.body}
                                    </Grid>
                                  </Grid>
                                </Fragment>
                              );
                            })}
                        </Collapse>
                      </Grid>
                      <Grid
                        container
                        justify="center"
                        className={classes.seeMore}
                        onClick={() => setSeeMore(!seeMore)}
                      >
                        {seeMore ? " بستن" : " بیشتر "}
                      </Grid>
                      <Grid
                        container
                        justify="center"
                        className={classes.setSeenAll}
                        onClick={() => handleSeenNotifications("all")}
                      >
                        حذف همه
                      </Grid>
                    </Grid>
                  </Fade>
                </div>
                {/* <img src={Document} className={classes.es5} alt="Document" style={{ marginLeft: 30 }} />
								 <div
                                    style={{
                                        width: 7,
                                        height: 7,
                                        backgroundColor: "red",
                                        borderRadius: "50%",
                                        position: "absolute",
                                        top: 4,
                                        right: 72,
                                    }}
                                />  */}
              </Grid>
              <ProfileSection />
            </Grid>
          ) : (
            <LoginSignUp />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
